module.exports = __webpack_public_path__ + "img/image17.bd15cda7.png";